import type { CreateSavedReportPayload, SavedReport } from '../interfaces';
import type { ApiResponse } from '@Types';
import { API } from '@Providers';

export default async function (payload: CreateSavedReportPayload) {
  const endpoint = '/api/shelter/saved-reports';

  return API({ endpoint, method: 'post', payload }) as Promise<ApiResponse<SavedReport>>;
}
